// --- React
import React from 'react';
// --- UI Components
import Button from '@dtci/spellbook/Button';
import { usePermissions } from '../../../utils/permissions';

/**
 * ClickableCellRenderer Component
 *
 * This component is a cell renderer for AG Grid that renders a clickable button.
 * It takes an action function and a button icon as props.
 * When the button is clicked, it performs the specified action.
 *
 * @param {Function} action - The action to be performed when the button is clicked.
 * @param {string} buttonIcon - The icon to be displayed on the button.
 * @returns {JSX.Element} The rendered button component.
 **/
export const ClickableCellRenderer = (action, buttonIcon) => {
    const { isLegalAdmin, isLegalUser, isProductCommentsAdmin } = usePermissions();

    const isActionDisabled = () => {
        const disabledActions = {
            'fa-comment': !isLegalAdmin && !isLegalUser && !isProductCommentsAdmin,
            'fa-pencil': !isLegalAdmin && !isLegalUser && !isProductCommentsAdmin,
            'fa-copyright': !isLegalAdmin && !isLegalUser && !isProductCommentsAdmin,
            'fa-file': !isLegalAdmin && !isLegalUser && !isProductCommentsAdmin,
            'fa-link': !isLegalAdmin && !isLegalUser && !isProductCommentsAdmin,
            'fa-circle-check': true,
        };
        return disabledActions[buttonIcon] || false;
    };

    const Renderer = ({ value, data }) => (
        <Button
            style={{ color: !isActionDisabled() ? '#3611c8' : '#6A8095' }}
            iconType={`fa-regular ${
                value === 'Not Verified' ? 'fa-solid fa-circle-x' : buttonIcon
            }`}
            type="button"
            styleType="link"
            className="sb-typography sb-typography_T20 sb-typography_truncate"
            onClick={action(data)}
            disabled={isActionDisabled()}
        >
            {value}
        </Button>
    );

    return Renderer;
};
